// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import CodeLabelStateConstants from 'constants/CodeLabelStateConstants'
import ColorConstants from 'constants/ColorConstants'
import { CODE_COLORS } from 'constants/CodeColorConstants';
import DimensionsConstants, {
  CODE_LABEL_HEIGHT
} from 'constants/DimensionsConstants';

import CodeLabelText from './ColorSelector/CodeLabelText'
import ColorSelector from './ColorSelector/ColorSelector'

const LEFT_BUFFER = "30px";
const BORDER_RADIUS = "5px"
const HEIGHT = CODE_LABEL_HEIGHT.toString() + "px"
const _BOTTOM_MARGIN_INT = 0;
const BOTTOM_MARGIN = _BOTTOM_MARGIN_INT.toString() + "px";
const MERGE_HEIGHT = (CODE_LABEL_HEIGHT * 2).toString() + "px";
const COLOR_BUTTON_WIDTH = 5;

const baseStyle = {
  "borderRadius": BORDER_RADIUS + " 0px 0px " + BORDER_RADIUS,
  "background": ColorConstants.ULTRA_LIGHT_GREY,
  "padding": "0px",
  "marginBottom": BOTTOM_MARGIN,
  "width": DimensionsConstants.CODE_LABEL_WIDTH - COLOR_BUTTON_WIDTH,
  "height": HEIGHT,
  "float": "left",
  color: ColorConstants.DARK_GREY
}

const hoverStyle = {
  boxShadow: "5px 4px 10px #00000033",
}

const mergeStyle = {
  height: MERGE_HEIGHT
}

class CodeLabelBody extends React.Component {
  getColor()
  {
    switch(this.props.state) {
      case CodeLabelStateConstants.CODE_MERGING_ENABLED:
      case CodeLabelStateConstants.CODE_MERGING_DISABLED:
        return ColorConstants.GHOST_COLOR;
      case CodeLabelStateConstants.CODE_GHOSTED:
        return ColorConstants.ULTRA_LIGHT_GREY;
      case CodeLabelStateConstants.CODE_SELECTED:
        return ColorConstants.LIGHT_GREY;
      case CodeLabelStateConstants.CODE_ENABLED:
        return ColorConstants.ULTRA_LIGHT_GREY;
      case CodeLabelStateConstants.CODE_DISABLED:
        return ColorConstants.ULTRA_LIGHT_GREY;
      default:
        return ColorConstants.ULTRA_LIGHT_GREY;
    }
  }

  getTextColor()
  {
    switch (this.props.state ) {
      case CodeLabelStateConstants.CODE_DISABLED:
      case CodeLabelStateConstants.CODE_MERGING_DISABLED:
        return ColorConstants.LIGHT_GREY;
      default:
        return ColorConstants.DARK_GREY;
    }
  }

  getStyle()
  {
    var labelCodeStyle = {
      ...baseStyle,
      color: this.getTextColor(),
      backgroundColor: this.getColor()
    }

    if ( this.props.dragOver && !this.props.ghost ){
      labelCodeStyle = {
        ...labelCodeStyle,
        ...hoverStyle
      };
    }

    if ( this.props.mergeParent || this.props.showConfirmMerge) {
      labelCodeStyle = {
        ...labelCodeStyle,
        ...mergeStyle
      }
    }

    return labelCodeStyle;
  }

  render () {
    // Ensure we only use transition if explicitly provided (not undefined)
    const transitionType = this.props.transitionType || null;
    const isDragging = this.props.isDragging;

    return (
      // width was + 43 originally, now I changed it to 60. But that was really haphazzard
      <div>
        <div 
          className={`code-label-body ${isDragging ? 'dragging' : ''}`} 
          data-transition={transitionType || undefined}
          style={this.getStyle()} 
          onClick={this.props.onClick}
        >
            <div style={{float:"left", marginBottom: "0px", paddingBottom: "0px"}}>
              <div style={{width: LEFT_BUFFER}}>
                {this.props.showCollapseGlyph &&
                  // 24px matches the old 10px glyphicon triangle: MUI's arrow
                  // only draws ~10px of its box, glyph fonts filled the em
                  <div onClick={this.props.onCollapseClicked}
                        style={{paddingLeft: '5px',
                                paddingTop: '4px',
                                fontSize:"24px",
                                lineHeight: 1,
                                cursor:"pointer"}}>
                    {this.props.collapsed
                      ? <ArrowRightIcon data-testid="ArrowRightIcon" fontSize="inherit" style={{color:this.getTextColor()}}/>
                      : <ArrowDropDownIcon data-testid="ArrowDropDownIcon" fontSize="inherit" style={{color:this.getTextColor()}}/>}
                  </div>
                }
                {!this.props.showCollapseGlyph && <div style={{width:LEFT_BUFFER, height:"10px"}}>{' '}</div>}
              </div>
            </div>

          <div>
            <CodeLabelText
                value={this.props.editableName}
                onBlur={this.props.onBlur}
                onFocus={this.props.onFocus}
                onChange={this.props.onChange}
                ghost={this.props.ghost}
                name={this.props.name}
                count={this.props.count}
                edit={this.props.edit}
                dragOver={this.props.dragOver}
                allowPopover={this.props.allowPopover}
                id={this.props.id}
                />
          </div>
        </div>
        {!this.props.isInMergeMode && (
          <ColorSelector state={this.props.state} codeId={this.props.id}>
            <div
              id={`color-button-${this.props.id}`}
              style={{
                "padding": "0",
                "marginBottom": "10px",
                "background": CODE_COLORS[this.props.color] || CODE_COLORS.grey,
                "height": HEIGHT,
                "width": COLOR_BUTTON_WIDTH,
                "float": "left",
                "cursor": "pointer"
              }}
              title="Click to change color"
            />
          </ColorSelector>
        )}
      </div>
    );
  }
}

export default CodeLabelBody;